import React from "react";

interface CourseTopic {
  id: number;
  title: string;
  imageUrl?: string;
  isLesson?: boolean;
}

const FALLBACK_TOPICS: CourseTopic[] = [
  { id: 1, title: "Introduction and Orientation", isLesson: false },
  { id: 2, title: "L1: The Power of Consistency", isLesson: true },
  { id: 3, title: "L2: Overcoming consistency Barriers", isLesson: true },
  { id: 4, title: "L3: Train yourself to be Godly", isLesson: true },
  { id: 5, title: "L4: The meaning of meditation", isLesson: true },
  { id: 6, title: "L5: The process of meditation", isLesson: true },
  { id: 7, title: "L6: Why reading the Bible consistently is difficult", isLesson: true },
  { id: 8, title: "L7: Partnering in spreading the CBR vision", isLesson: true },
  { id: 9, title: "Setting Lifestyle CBR Goals", isLesson: false },
  { id: 10, title: "Graduation Ceremony", isLesson: false },
];

const CourseTopics: React.FC = () => {
  const getTopicIcon = () => (
    <svg className="w-16 h-16 text-[#7590AB]/80" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM18.82 9L12 12.72L5.18 9L12 5.28L18.82 9ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99Z" />
    </svg>
  );

  const getLessonIcon = (lessonNumber: number) => (
    <div className="w-16 h-16 rounded-full border-[3px] border-[#7590AB]/80 flex items-center justify-center text-[#7590AB]/80">
      <span className="font-bold text-3xl">{lessonNumber}</span>
    </div>
  );

  const renderTitle = (title: string, id: number) => {
    if (id >= 2 && id <= 8) {
      const match = title.match(/^(L\d+):\s*(.*)$/);
      if (match) {
        return (
          <div className="flex flex-row items-center justify-center gap-3 text-left">
            <span className="inline-flex items-center justify-center w-10 h-10 rounded-full border-2 border-navYellow text-navYellow font-bold text-sm shrink-0">
              {match[1]}
            </span>
            <span className="flex-1 leading-tight">{match[2]}</span>
          </div>
        );
      }
    }
    return <span>{title}</span>;
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 lg:px-4 text-center mb-16">
        <p className="text-navYellow font-medium tracking-widest text-xl mb-3">CBR Sessions</p>
        <h2 className="text-3xl md:text-4xl font-semibold text-darkBlue">Course Topics & Sessions</h2>
      </div>

      <div className="container mx-auto px-4 lg:px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {FALLBACK_TOPICS.map((topic, index) => (
            <div key={topic.id || index} className="flex flex-col items-center text-center">
              <div className="w-32 h-32 rounded-full bg-blue-50/50 flex items-center justify-center mb-4 transition-transform hover:scale-105 tooltip-wrapper">
                {topic.imageUrl ? (
                  <img src={topic.imageUrl} alt={topic.title} className="w-24 h-24 object-contain" />
                ) : (
                  topic.id >= 2 && topic.id <= 8 ? getLessonIcon(topic.id - 1) : getTopicIcon()
                )}
              </div>
              <h3 className="font-semibold text-lg text-darkBlue px-2 mt-2">
                {renderTitle(topic.title, topic.id)}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CourseTopics;
